import gql from 'graphql-tag'

export const CREATE_CTOWER_LOG = gql`
  mutation CreateCtowerLog($input: CreateCtowerLogInput!) {
    createCtowerLog(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createCtowerLog {
        companyId
        userId
        vehicleId
        viewedOn
        uncheckedVehicle
        alertViewed
      }
    }
  }
`

export const UPDATE_CTOWER_USER_PLACARD = gql`
  mutation UpdateCtowerUserPlacard($input: UpdateCtowerUserPlacardInput!) {
    updateCtowerUserPlacard(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateCtowerUserPlacard {
        userId
        vehicleId
        isPinned
        asArray
      }
    }
  }
`

export const CTOWER_USER_PLACARDS = gql`
  query CtowerUserPlacards($filter: GetCtowerUserPlacardsInput) {
    ctowerUserPlacards(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      ctowerUserPlacards {
        isPinned
        userId
        vehicleId
        asArray
      }
    }
  }
`

export const GET_USER_PREFERENCES = gql`
  query UserPreferences {
    userPreferences {
      isSuccessful
      errorCode
      errorName
      message
      status
      userPreferences {
        entityType
        fieldType
        label
        value
      }
    }
  }
`

export const CREATE_USER_PREFERENCES = gql`
  mutation CreateUserPreference($input: CreateUserPreferenceInputType!) {
    createUserPreference(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createUserPreference {
        entityType
        fieldType
        label
        value
      }
    }
  }
`

export const UPDATE_USER_PREFERENCES = gql`
  mutation UpdateUserPreference($input: UpdateUserPreferenceInputType!) {
    updateUserPreference(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateUserPreference {
        entityType
        fieldType
        label
        value
      }
    }
  }
`

export const DELETE_USER_PREFERENCES = gql`
  mutation DeleteUserPreference($input: DeleteUserPreferenceInputType!) {
    deleteUserPreference(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deleteUserPreference {
        entityType
        fieldType
        label
        value
      }
    }
  }
`
